import { render, staticRenderFns } from "./PlayerStatisticsScreen.vue?vue&type=template&id=1bda4996&"
import script from "./PlayerStatisticsScreen.vue?vue&type=script&lang=js&"
export * from "./PlayerStatisticsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports